export enum ContextMenuOptions {
  CONNECT_ROUTE = 'connectRoute',
  CONNECT_EMPLOYEE = 'connectEmployee',
  CHANGE_TO_BICYCLE = 'changeToBicycle',
  CHANGE_TO_CAR = 'changeToCar',
  EDIT_ROUTE_START = 'editRouteStart',
  SHOW_ROUTE_ON_MAP = 'showRouteOnMap',
  REMOVE_ASSIGNMENT_EMPLOYMENT_TO_APPOINTMENT_GROUPING = 'removeAssignmentEmploymentToAppointmentGrouping'
}
